import ConfirmAction from '@/components/confirm-action';
import PageToolbar from '@/components/linear/page-toolbar';
import { issuesPath, myIssuesPath, viewPath } from '@/lib/linear-paths';
import { deleteView, listViews, type SavedView as LocalView } from '@/lib/views';
import { Link, router } from '@inertiajs/react';
import { useEffect, useState } from 'react';

interface ServerView {
  id: string;
  name: string;
  query?: string;
  href: string;
}

interface Props {
  builtinViews?: Array<{ key: string; name: string; href?: string }>;
  savedViews?: ServerView[];
}

const FALLBACK_BUILTIN = [
  { id: 'all', name: 'All issues', href: issuesPath() },
  { id: 'active', name: 'Active', href: `${issuesPath()}?view=active` },
  { id: 'backlog', name: 'Backlog', href: `${issuesPath()}?view=backlog` },
  { id: 'mine', name: 'My issues', href: myIssuesPath() },
];

export default function Index({ builtinViews, savedViews = [] }: Props) {
  const [local, setLocal] = useState<LocalView[]>([]);

  useEffect(() => {
    const refresh = () => setLocal(listViews());
    refresh();
    window.addEventListener('caprock:views', refresh);
    return () => window.removeEventListener('caprock:views', refresh);
  }, []);

  const builtin =
    builtinViews && builtinViews.length > 0
      ? builtinViews.map((view) => ({
          id: view.key,
          name: view.name,
          href: view.href ?? issuesPath(),
        }))
      : FALLBACK_BUILTIN;

  const custom = savedViews.length > 0 ? savedViews : local;

  return (
    <div className="ln-page">
      <PageToolbar title="Views" showNew={false} />
      <div className="ln-page-scroll">
        {builtin.map((view) => (
          <Link key={view.id} href={view.href} className="ln-row">
            <span className="ln-row-title">{view.name}</span>
          </Link>
        ))}
        {custom.length > 0 ? (
          <>
            <div className="ln-group-header">
              <div className="ln-group-toggle" style={{ cursor: 'default' }}>
                Custom
                <span className="ln-group-count">{custom.length}</span>
              </div>
            </div>
            {custom.map((view) => (
              <div key={view.id} className="ln-row">
                <Link href={view.href} className="ln-row-title" style={{ color: 'inherit' }}>
                  {view.name}
                </Link>
                <ConfirmAction
                  title="Delete view?"
                  onConfirm={() => {
                    if (savedViews.length > 0) {
                      router.delete(viewPath(view.id));
                      return;
                    }
                    deleteView(view.id);
                  }}
                >
                  <button type="button" className="ln-toolbar-btn">
                    Delete
                  </button>
                </ConfirmAction>
              </div>
            ))}
          </>
        ) : (
          <div className="ln-view-hint">Save a view from the issues Display menu.</div>
        )}
      </div>
    </div>
  );
}
